import React from 'react';
import classNames from 'classnames';

import questionData from './QuizData';

const Question = ({activeQuestion, setAnswer, responces}) => {
  const data = questionData[activeQuestion - 1];

  return (
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="question">
          <p class="quiz--question-number">{lang.QUESTION} {data.id}</p>
          <h2>{data.question}</h2>
        </div>
      </div>
      <div class="col-12 col-md-5 offset-md-1">
        <div class="answers">
          {data.responces.map((resp) => (
            <button class={classNames('answer', { checked: (responces[activeQuestion - 1] === resp.value) })} onClick={() => setAnswer(data.id, resp.value)}>
              {resp.text}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Question;
